<template>
  <div class="orderDetailPop ">
    <el-dialog :visible="isShow" width="800px" :show-close="false" :close-on-click-modal="false" :appendToBody='true'
      @close="fCancalPopupShow">
      <div class="x-sm-pop-head x-bd-bottom" style="background-color: #fff;">
        <div class="x-flex">
          <div class='x-flex x-h50 x-m-r-20'>{{ fLng('存储空间续费', 'orderDetail') }}
          </div>
        </div>
        <div class="x-flex ">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;"
            @click="fCancalPopupShow"></i>
        </div>
      </div>

      <div class="x-flex c-24" style="align-items: flex-start;box-sizing: border-box;height: 500px;">
        <div style="background-color:#f6f7f8 ;height: 100%;width: 220px;">
          <div class="x-text-c x-m-20 x-p-b-20" style="border-bottom: 1px solid #E0E4E8;">
            <img src="@/assets/img/renew_mall_icon.png" alt="">
            <div class="x-p-t-20 x-font-16  ">{{ info.mch_name }}</div>
          </div>
          <div class="x-p-l-20 ">
            <div class="c-80">门店名称</div>
            <div class="x-p-t-6">{{ info.mall_name }}</div>
            <div class="c-80 x-p-t-20">商户门店号</div>
            <div class="x-p-t-6">{{ info.mall_id }}</div>
            <div class="c-80 x-p-t-20">到期时间</div>
            <div class="x-p-t-6">{{ api.timeHelper.fDateFat('yyyy-MM-dd', info.exp_time,) }}</div>
          </div>

        </div>
        <div class="x-m-b-30 x-flex-1" v-if="step == '1'">
          <el-row class="x-flex x-w100p x-p-t-10">
            <el-col :span="20" class="x-p-l-20">
              <div class="timeTitleContainer x-p-t-10">
                <span :class="['timeTitleItem', { active: activeTab === 'smxf' }]"
                  @click="fSwitchTimeTab('smxf')">扫码续费</span>
                <span :class="['timeTitleItem', { active: activeTab === 'jhm' }]"
                  @click="fSwitchTimeTab('jhm')">激活码激活</span>
              </div>
            </el-col>
          </el-row>
          <div class="x-flex x-wrap x-p-l-30 x-p-r-30 x-p-t-20">

            <!-- <el-radio v-for="option in payOptions" :key="option.value" :label="option.value" v-model="actInfo.value"
                @change="fOnPayOptionChange(option)">
                {{ option.label }}
              </el-radio> -->
            <div class="x-flex" v-if="activeTab === 'smxf'">
              <div class="spec-item" :class="{ 'spec-active': option.id == actInfo.id }"
                v-for="(option, index) in mchPayOptions" :key="option.id" @click="fOnPayOptionChange(option)">
                <!-- <div class="spec-img">
                  <img v-if="index == 0" src="@/views/shop/shopImg/xszk.png" class="x-w100p" />
                  <img v-if="index == 1" src="@/views/shop/shopImg/zdrx.png" class="x-w100p" />
                  <img v-if="index == 2" src="@/views/shop/shopImg/zhs.png" class="x-w100p" />
                </div> -->
                <div class="x-p-b-10 x-font-18 f600">{{ option.label }}</div>
                <div class="x-p-b-5 x-font-18 ">￥{{ option.ord_amt }}</div>
                <div class="c-80 x-p-b-15">每天<span class="f600 c-smRed">{{ Number(api.numHelper.fNumDiv(option.ord_amt,
                  option.pro_val)).toFixed(2) }}</span> 元</div>
                <div class="c-80 " style="text-decoration: line-through;">原价：￥{{ option.orig }}</div>
              </div>

            </div>
            <div
              style="width: 100%;height: 210px; display:flex; align-items:center; justify-content:center; flex-direction:column;"
              v-else>
              <div class="x-w100p x-text-l x-font-16 x-p-b-20">请输入激活码</div>
              <el-input v-model="act_code" placeholder="请输入激活码" style="width: 100%;"></el-input>
            </div>

          </div>
          <div class="x-p-30 c-80 x-font-16">
            <div>温馨提示：你的数据存储在阿里云上，请放心一切数据安全！</div>
            <div class="x-p-t-10">如有疑问请拨打：4008768278</div>
          </div>
          <div class="x-flex  x-row-right x-p-30" style="margin-top: 24px;">
            <x-button :title="fLng('立即支付', 'dish')" @click.native="fNext('2')"></x-button>

          </div>
        </div>
        <div class="x-m-30 x-flex-1 x-flex x-col-center x-row-center" v-if="step == '2'">
          <div class="x-text-c">
            <div class="x-font-18 f600 x-p-b-10">{{ actInfo.label }}</div>
            <div class="x-p-b-20">金额：{{ actInfo.ord_amt }}</div>
            <div class="x-w240 x-h240 x-bd x-bd-ra x-flex x-row-center x-m-a">
              <div id="qrcodeMax" ref="qrCodeUrlMax"></div>
            </div>
            <div class="x-p-t-10 x-p-b-40">
              打开支付宝或微信扫一扫
            </div>
            <x-button :title="fLng('我已完成支付', 'dish')" @click.native="fNext('3')"></x-button>
          </div>
        </div>
        <div class="x-m-30 x-flex-1 x-flex x-col-center x-row-center" v-if="step == '3'">
          <div class="x-text-c">
            <div class="x-font-18  x-p-b-10 x-p-t-40">数据存储空间续费成功</div>
            <div class="x-p-b-20 x-p-t-40 x-font-24 f600 c-smRed">{{ actSucess.label }}</div>
            <div class="x-p-b-20 x-font-18 c-smRed">{{ actSucess.exp_time }}</div>
            <div class="x-p-b-10 x-p-t-20">感谢您的支持，有任何问题可以联系我们</div>
            <div class=" x-p-b-40">
              你的满意，一直是我们不懈的追求！
            </div>
            <div class="x-p-t-40">
              <x-button size="large" :title="fLng('开始使用', 'dish')" @click.native="fNext('4')"></x-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 轮询期间的loading遮罩层 -->
      <div v-if="isPolling" class="loading-mask">
        <div class="loading-content">
          <!-- <el-loading-spinner class="el-icon-loading"></el-loading-spinner> -->
          <p class="loading-text">正在查询支付状态，请稍候...</p>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  props: {
    // 是否显示
    isShow: {
      type: [String, Boolean],
      default: false,
    },

    info: {
      type: [Object],
      default: {},
    },
    mall_id: {
      type: [String],
      default: '',
    },
    editType: {
      type: [String],
      default: '',
    },

  },
  data() {
    return {
      orderDetailInfo: {},
      tableData: [],
      activeTab: 'smxf',
      step: '1',
      mchPayOptions: [],
      orgPayOptions: [],
      payOptions: [],
      actInfo: {}, // 初始化选中项对象
      act_code: '',// 激活码输入
      ord_id: '',
      pay_url: '',
      isPolling: false, // 防止重复点击
      actSucess: {}, // 激活成功返回数据
    };
  },
  watch: {
    isShow(val) {
      this.step = '1'
      console.log(val)
      if (val) {
        this.init()
      }
    },
  },
  mounted() {

  },
  async created() {
    this.init()
  },
  methods: {
    async init() {

      // 可以在这里加载用户信息或其他初始化数据 获取商店商品
      console.log('短信充值页面初始化');
      let oJn = {
        OPER: 'PRO_ID', // 操作
        DSP_CA: 'SIM', // 显示客户端程序 SIM简易显示 APPLET小程序端 WIN电脑端
        PRO_ID: this.$store.state.djsAdmin.saas_type_id == 'sipCy' ? '1002' : '1001', //
      }
      console.log(this.$store.state.djsAdmin.saas_type_id, '获取商品信息')
      let res = await this.api.djsApi.fSmCloudQueryApi({
        methodName: 'GET_SHOP_PRO_INFO',
        js: oJn,
        mchId: '320250710',
        userId: '320250710',
        signType: 'MD5',
        sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
        sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
      })
      if (res.result != 'sucess') {
        this.$message.error(res.msg || '获取商品失败，请稍后重试');
        return
      }
      let spec_ja = JSON.parse(res.data.spec_ja)
      let price_jn = JSON.parse(res.data.price_jn)

      // 将spec_ja和price_jn转换为payOptions格式的两个数组
      // 基于组织价格的payOptions
      // this.orgPayOptions = spec_ja.map((item, index) => {
      //   const price = price_jn.org[item.id];
      //   return {
      //     id: index + 1,
      //     value: price,
      //     label: `${price}元/${item.lng}`,
      //     ord_amt: `${price}`,
      //     pro_val: item.val
      //   };
      // });

      // 基于商户价格的payOptions
      this.mchPayOptions = spec_ja.map((item, index) => {
        const price = price_jn.mch[item.id];
        return {
          id: index + 1,
          value: price.sale,
          label: `${item.lng}`,
          ord_amt: `${price.sale}`,
          pro_val: item.val,
          orig: price.orig
        };
      });

      console.log('组织价格选项:', this.orgPayOptions);
      console.log('商户价格选项:', this.mchPayOptions);

      // 默认使用商户价格选项
      this.payOptions = this.mchPayOptions;
      // 更新默认选中项 - 只设置value属性，保持对象结构不变
      if (this.mchPayOptions.length > 0) {
        this.actInfo = {
          ...this.actInfo,
          id: this.mchPayOptions[0].id,
          value: this.mchPayOptions[0].value,
          label: this.mchPayOptions[0].label,
          ord_amt: this.mchPayOptions[0].ord_amt,
          pro_val: this.mchPayOptions[0].pro_val,
          orig: this.mchPayOptions[0].orig
        }
      }
    },
    fSwitchTimeTab(tab) {
      this.activeTab = tab
    },
    fOnPayOptionChange(option) {
      // 直接赋值选中项，不需要nextTick
      this.actInfo = { ...option };
      console.log('选中的选项:', this.actInfo);
    },
    async fGetPayUrl() {
      try {
        // 初始化相关状态，避免状态冲突
        this.ord_id = '';
        this.pay_url = '';

        let oJn = {
          ORG_ID: this.$store.state.djsAdmin.org_id, // 机构号
          MCH_ID: this.$store.state.djsAdmin.mch_id, // 商户ID
          MALL_ID: this.$store.state.djsAdmin.mall_id, // 门店ID
          PRO_ID: this.info.saas_type_id == 'sipCy' ? '1002' : '1001', // 商店商品ID
          // ORD_AMT: '0.01', // 单据金额
          // PRO_AMT: '0.01', // 商品值 如短信充值条数，续费天数
          ORD_AMT: this.actInfo.ord_amt || '0', // 单据金额
          PRO_AMT: this.actInfo.ord_amt,//商品金额
          
          ERP_NAME: this.info.saas_type_id == 'sipCy' ? 'djsCy' : 'djsLs', // erp名称
          // PRO_VAL: '10', // 商品值 如短信充值条数，续费天数
          PRO_VAL: this.actInfo.pro_val || '0', // 商品值 如短信充值条数，续费天数
          
          DIS_AMT: '0.00',//优惠金额
          TRACK_ADR: '', // 收货地址
          ORD_REMARK: '', // 订单备注

          PAY_ORG_ID: '', // 支付机构id  服务商代商户购买时的机构id 否则为空
          REF_USER_ID: '', // 推荐人id

          CHG_USER_ID: this.$store.state.djsAdmin.user_id, // 修改员工id
          CHG_USER_NAME: this.$store.state.djsAdmin.user_name, // 修改员工姓名
          REMARK: '', // 备注 可选

          SM_PAY_WAY: 'CSB_PAY', // 尚米支付方式 CSB_PAY  JS_PAY  APPLET_PAY
          // PAY_TYPE: string; // 支付渠道  WECHAT 微信ALIPAY 支付宝 UNIONPAY 银联
          // PAY_WAY: string; // 支付方式 02微信公众号,支付宝生活号,银联js支付,支付宝小程序 03 微信小程序
          // OPEN_ID: string;
        }
        let res = await this.api.djsApi.fSmCloudAdminApi({
          methodName: 'CRT_SHOP_PAY_CODE',
          js: oJn,
          mchId: '320250710',
          userId: '320250710',
          signType: 'MD5',
          sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
          sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
        })

        if (res.result !== 'sucess') {
          return this.$message.error(res.msg);
        }
        this.ord_id = res.ord_id
        this.pay_url = res.pay_url
        this.fCreateQRcode(this.pay_url)

      } catch (error) {
        console.error('Error in init:', error);
        this.$message(error.message || 'An unexpected error occurred');
      }
    },
    async fCreateQRcode(url) {
      // 统一使用ref访问DOM元素，确保完全清除旧的二维码
      const qrCodeContainer = this.$refs.qrCodeUrlMax;
      if (qrCodeContainer) {
        // 清除容器内所有内容，确保彻底移除旧二维码
        qrCodeContainer.innerHTML = "";
        let text = url;
        // 在已清空的容器中创建新的二维码
        new QRCode(qrCodeContainer, {
          text, // 需要转换为二维码的内容
          width: 220,
          height: 220,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
    },
    async fNext(step) {
      if (step == '4') {
        this.$emit('sucess', true)
        return
      }
      if (step == '2') {
        if (this.activeTab == 'smxf') {
          this.step = step
          this.fGetPayUrl()

        } else {
          if (this.api.smCom.fSmIsEmpty(this.act_code)) {
            return this.$message.error('请输入激活码');
          }
          // 弹窗二次确认
          try {
            await this.$confirm('确认使用激活码激活？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
          } catch (error) {
            // 用户取消
            return
          }

          let oJn = {}
          oJn['OPER'] = 'ACT_MCH_MALL'
          oJn['CODE'] = this.act_code
          oJn['TYPE_ID'] = this.info.saas_type_id
          oJn['MCH_ID'] = this.$store.state.djsAdmin.mch_id
          oJn['MALL_ID'] = this.info.mall_id
          oJn['REMARK'] = 'WEB激活'
          oJn['ORG_ID'] = this.$store.state.djsAdmin.org_id
          oJn['CHG_ORG_ID'] = this.$store.state.djsAdmin.org_id
          oJn['CHG_USER_ID'] = this.$store.state.djsAdmin.org_id
          let resAct = await this.api.djsApi.fSmCloudAdminApi({
            methodName: 'ACT_CODE_INFO',
            js: oJn,
            mchId: '320250710',
            userId: '320250710',
            signType: 'MD5',
            sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
            sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
          })
          console.log(resAct)

          if (resAct.result !== 'sucess') {
            return this.$message.error(resAct.msg);
          }
          // Object.assign(this.actSucess, resAct)
          // Object.assign(this.actSucess, {
          //   "result": "sucess",
          //   "msg": "激活商户成功",
          //   "sub_msg": "38568723",
          //   "code": "HVLUK8VB",
          //   "exp_time": "2226-09-10 14:19:08",
          //   "exp_day": "73362",
          //   "state_id": "sipYjh",
          //   "state_lng": "已激活"
          // })
          this.$emit('updata', this.actSucess)
          this.step = '3'
          // return resAct;
        }
        return
      }
      if (step == '3') {
        this.fSave()
      }
    },
    async fSave() {
      // 防止重复点击
      if (this.isPolling) {
        console.log('正在轮询支付状态，请等待...');
        return;
      }

      // 设置轮询状态为正在进行
      this.isPolling = true;

      let pollCount = 0;
      const maxPollCount = 5;

      // 轮询函数
      const checkPaymentStatus = async () => {
        // 避免超出最大查询次数
        if (pollCount >= maxPollCount) {
          this.$message.error('支付超时，请检查您的支付状态');
          this.isPolling = false; // 重置轮询状态
          return false;
        }

        pollCount++;
        console.log(`第${pollCount}次查询支付状态`);

        let oJn = {
          OPER: 'STATE', // 操作
          DSP_CA: 'SIM', // 显示客户端程序 SIM 简易列表 APPLET小程序端 WIN电脑端
          ORD_ID: this.ord_id, // 订单id
        }

        try {
          let res = await this.api.djsApi.fSmCloudQueryApi({
            methodName: 'GET_SHOP_ORD_DETAIL',
            js: oJn,
            mchId: '320250710',
            userId: '320250710',
            signType: 'MD5',
            sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
            sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
          })

          if (res.result !== 'sucess') {
            // 接口调用失败但未达到最大次数时继续轮询
            if (pollCount < maxPollCount) {
              return true; // 继续轮询
            } else {
              this.$message(res.msg);
              this.isPolling = false; // 重置轮询状态
              return false;
            }
          }

          // 支付成功
          if (res.data && res.data.pay_state_id == 'sipYfk') {
            this.isPolling = false; // 重置轮询状态
            this.paySuccessPop = true // 先设置支付成功弹窗显示
            this.actSucess.exp_time = res.data.mch_pro_val
            this.$emit('updata', this.actSucess)
            this.step = '3'
            return false; // 结束轮询
          }

          // 支付未完成，继续轮询
          return true;
        } catch (error) {
          console.error('查询支付状态失败:', error);
          // 发生错误但未达到最大次数时继续轮询
          if (pollCount < maxPollCount) {
            return true;
          } else {
            this.$message.error('查询支付状态失败，请稍后重试');
            this.isPolling = false; // 重置轮询状态
            return false;
          }
        }
      }

      // 执行轮询
      let shouldContinue = true;
      while (shouldContinue) {
        shouldContinue = await checkPaymentStatus();

        // 如果需要继续轮询，则等待1秒
        if (shouldContinue) {
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
    },
    fCancalPopupShow() {
      this.$emit('close')
    }
  },
}
</script>

<style lang="less" scoped>
.orderDetailPop {
  background-color: #fff;
}

.spec-item {
  width: 160px;
  height: 190px;
  background: #FFFFFF;
  border-radius: 8px;
  position: relative;
  margin-right: 20px;
  margin-top: 20px;
  border: 1px solid #ECECEC;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.spec-active {
  border: 2px solid #FF6801;
  background-color: #FFFBF7;
}

.spec-img {
  position: absolute;
  top: -25px;
  left: 50%;
  width: 100px;
  z-index: 1;
  transform: translateX(-50%);
}

// 时间标题项样式
.timeTitleItem {
  padding: 0 15px 10px;
  cursor: pointer;
  //  
  font-size: 14px;
  transition: color 0.3s;
  position: relative;
  margin-right: 20px;

  &:hover {
    color: #409eff;
  }

  // 激活状态样式
  &.active {
    color: #409eff;

    // 下划线效果
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 15px;
      right: 15px;
      height: 2px;
      background-color: #409eff;
    }
  }
}

.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-text {
  margin-top: 10px;
   
}
</style>



// WEBPACK FOOTER //
// src/views/renew.vue